/**
 * The read-only Node.nodeType property is an integer that identifies what the node is. It distinguishes different kind of nodes from each other, such as elements, text and comments.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
 */
export const NODE_TYPE = {
    /** An Element node like `<p>` or `<div>`. */
    ELEMENT_NODE: 1,
    /** The actual Text inside an Element or Attr. */
    TEXT_NODE: 3,
    /** A Comment node, such as `<!-- … -->`. */
    COMMENT_NODE: 8,
};
